import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataModel } from '../../models/data-model.model';
import { ListResult } from '../../models/list-result';

export abstract class DataService<TData extends DataModel> {
    protected abstract apiUrl: string;
    protected abstract http: HttpClient;
    protected static readonly urlPrefix = '/api/';
    protected static readonly contentType = { 'Content-Type': 'application/query.api+json' };
    static readonly plainJsonContentType = { 'Content-Type': 'application/json' };

    protected get endpoint(): string {
        return `${DataService.urlPrefix}${this.apiUrl}`;
    }

    update(data: TData): Promise<TData> {
        // @ts-ignore
        return this.http.patch<TData>(this.endpoint, data, { headers: DataService.plainJsonContentType }).toPromise();
    }

    delete(id: string): Observable<TData> {
        return this.http.delete<TData>(`${this.endpoint}/${id}`, { headers: DataService.plainJsonContentType });
    }

    async getById(id: string, httpParams: HttpParams = new HttpParams()): Promise<TData> {
        httpParams = this.cleanHttpParams(httpParams);
        const result = await this.http.get<{ data: TData }>(`${this.endpoint}/${id}`, { headers: DataService.contentType, params: httpParams }).toPromise();

        // @ts-ignore
        return Object.assign(this.createNewInstance(), result.data);
    }

    async getList(httpParams: HttpParams = new HttpParams(), urlSuffix?: string): Promise<ListResult<TData>> {
        httpParams = this.cleanHttpParams(httpParams);
        const url = urlSuffix ? `${this.endpoint}/${urlSuffix}` : `${this.endpoint}`;
        const result = await this.http
            .get<{ data: TData[]; meta: { totalRecordCount: number } }>(`${url}`, { headers: DataService.contentType, params: httpParams })
            .toPromise();

        // @ts-ignore
        const mappedData = result.data.map(entity => Object.assign(this.createNewInstance(), entity));

        // @ts-ignore
        return new ListResult(mappedData, result.meta.totalRecordCount);
    }

    protected abstract createNewInstance(): TData;

    protected cleanHttpParams(httpParams: HttpParams): HttpParams {
        httpParams.keys().forEach(key => {
            const allParams = httpParams.getAll(key);

            if (allParams != null) {
                if (allParams.filter(val => val != null && val !== '').length === 0) {
                    httpParams = httpParams.delete(key);
                }
            }
        });
        return httpParams;
    }
}
